(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareController', TabFirmwareController);

    TabFirmwareController.$inject = ['$scope', '$state', 'TabFirmware', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'paginationConstants'];

    function TabFirmwareController($scope, $state, TabFirmware, ParseLinks, AlertService, DataUtils, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabFirmware = [];
        vm.tabFirmwareInactive = [];
        vm.transition = transition;
        //vm.predicates = {};
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-firmware";
        vm.currentStateFilter = "tab-firmware-filter";
        vm.objectType = pagingParams.objectType;
        vm.applyFilter = applyFilter;
        var filter = localStorage.getItem(vm.currentStateFilter);
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectType = filter.objectType;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            };
            addFilter(body);
            TabFirmware.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabFirmware = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabFirmware.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        vm.loadInactive = function(tabFirmwareActive) {
            TabFirmware.load({address: tabFirmwareActive.address, objectTypeId: tabFirmwareActive.objectType.id, idShowed : tabFirmwareActive.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.tabFirmwareInactive[tabFirmwareActive.address + tabFirmwareActive.objectType.objectTypeName] = [];
                vm.tabFirmwareInactive[tabFirmwareActive.address + tabFirmwareActive.objectType.objectTypeName] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabFirmware = [];
            var orderCall = vm.loadAll();
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(objectType) {
            var filter={};
            filter.objectType = vm.objectType = objectType;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.page = pagingParams.page;
            vm.tabFirmware = [];
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.objectType.id !== -1)
                body.objectTypeId = vm.objectType.id;
        }

        vm.loadAll();

    }
})();
